import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  Box,
  TextField,
  Button,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { validationSchemaLogin } from "../../../validation/ValidationSchema";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux"; // Import useDispatch
import { selectError, selectIsLoading } from "../../../features/auth/authSlice";
import { loginUser } from "../../../features/auth/authThunk";

const LoginForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch(); // Initialize dispatch
  const isLoading = useSelector(selectIsLoading);
  const error = useSelector(selectError);
  const [showPassword, setShowPassword] = useState(false);
  // const [loading, setLoading] = useState(false);
  // const [errorMessage, setErrorMessage] = useState("");
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchemaLogin),
  });

  const onSubmit = async (data) => {
    try {
      // Dispatch the login thunk action
      await dispatch(loginUser({
        email: data.email,
        password: data.password
      })).unwrap();
      
      // Navigate to the next page on successful login
      navigate("/mail-verification");
    } catch (error) {
      // Error handling is now managed by the thunk and stored in Redux state
      console.error("Login error:", error.message);
    }
  };

  return (
    <Box className="templateForm__inner --verification">
      <h3 className="templateForm__title">Accedi con il tuo account</h3>
      <Box
        component="form"
        onSubmit={handleSubmit(onSubmit)}
        sx={{ "& > *": { mb: 2.5 } }}
      >
        <TextField
          fullWidth
          id="outlined-basic"
          label="Indirizzo mail"
          variant="outlined"
          {...register("email")}
          error={!!errors.email}
          helperText={errors.email?.message}
        />
        <div
          className="passwordText"
          variant="body2"
          color="textSecondary"
          component="a"
          onClick={() => navigate("/forgot-password")}
        >
          password dimenticata?
        </div>
        <TextField
          fullWidth
          id="outlined-password"
          label="Password"
          variant="outlined"
          type={showPassword ? "text" : "password"}
          {...register("password")}
          error={!!errors.password}
          helperText={errors.password?.message}
          slotProps={{
            input: {
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                    sx={{ color: "#6C757D" }}
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            },
          }}
        />
        {error && (
          <Box sx={{ color: "red", textAlign: "center", marginBottom: 2 }}>
            {error}
          </Box>
        )}
        <Button
          className="loginBtn"
          type="submit"
          fullWidth
          variant="contained"
          disableElevation
          sx={{
            bgcolor: "#225CA6",
            "&:hover": {
              bgcolor: "#225CA6",
            },
          }}
          disabled={isLoading}
        >
          {isLoading ? "Accedi..." : "Accedi"}
        </Button>
      </Box>
    </Box>
  );
};
export default LoginForm;
